import React from "react";
import Card from "../components/Card";
import Container from "react-bootstrap/Container";
import Category from "../components/Category";
import "../components/Carousel.scss";
import { withRouter } from 'react-router';
import P5Canvas from "./P5Canvas/P5Canvas";

class Carousel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clicks: props.defaultClicks,
      columnsNumber: 2,

      items: [
        {
          id: 0,
          title: "]Either or[ [both and also]",
          subTitle: "10 games in metaxourgeio",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752422/HomePage%20Thumbs/Main_View_Night_u4esa4_fyrjdc.jpg",
          selected: false,
          category: "culture",
        },
        {
          id: 13,
          title: "Blade Runner",
          subTitle: "Research project on a custom made Die Machine",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752423/HomePage%20Thumbs/General-View-Suction-Angle_wypsz9_plnvlv.jpg",
          selected: false,
          category: "culture",
        },
        {
          id: 7,
          title: "Behind Creation",
          subTitle: "Exploring the subface 'Damage behind creation'",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752423/HomePage%20Thumbs/Behind_Creation_Miltos_Tsakiris_b12fu9_tke5ov.jpg",
          selected: false,
          category: "competition",
        },
        {
          id: 1,
          title: "Pavillion",
          subTitle:
            "Ephimeral construction in the roman centre of Thessaloniki",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752423/HomePage%20Thumbs/Pavillion_lcrqev_wqatzv.jpg",
          selected: false,
          category: "architecture",
        },
        {
          id: 2,
          title: "Wireframe",
          subTitle: "Collabrotaive kitchen for Cook8",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752424/HomePage%20Thumbs/Render_zxsyjs_tzxvcl.jpg",
          selected: false,
          category: "competition",
        },
        {
          id: 3,
          title: "Solobot",
          subTitle: "A creative robot",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752424/HomePage%20Thumbs/Solobot_klueg8.jpg",
          selected: false,
          category: "interaction",
        },
        {
          id: 4,
          title: "Poster Generator",
          subTitle: "Bauhaus inspired generative and interactive poster",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752423/HomePage%20Thumbs/Poster_Generator_rd0afz_aicieb.png",
          selected: false,
          category: "creative-coding",
        },
        {
          id: 5,
          title: "Allatini",
          subTitle:
            "Urban Re-design project of the factory of Allatini in Thessaloniki",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752425/HomePage%20Thumbs/21_edited_jz1nsu_tp0qwk.jpg",
          selected: false,
          category: "urbanism",
        },
        {
          id: 6,
          title: "Rube Goldberg Machine",
          subTitle: "A chain of actuators and sensors",
          imgSrc:
            "https://res.cloudinary.com/dcoz5uxjg/image/upload/v1596796770/Rube%20Goldberg%20Machine/Arduino_Workshop_z6grae.jpg",
          selected: false,
          category: "prototype",
        },

        {
          id: 8,
          title: "Bitmap Choir",
          subTitle: "A collaborative music game",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752422/HomePage%20Thumbs/lala-100_tnqpjj_qpkwoc.jpg",
          selected: false,
          category: "competition",
        },
        {
          id: 9,
          title: "PopCorn Arcade",
          subTitle: "⚡NEEDS DESCRIPTION⚡",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752423/HomePage%20Thumbs/PopCorn_Arcade_vhlsnp_lweuzs.png",
          selected: false,
          category: "experiment",
        },
        {
          id: 10,
          title: "MoCA",
          subTitle: "⚡NEEDS DESCRIPTION⚡",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752420/HomePage%20Thumbs/IMG_3097_ima6qf_lhnxlm.jpg",
          selected: false,
          category: "competition",
        },
        {
          id: 11,
          title: "Ambiances",
          subTitle: "⚡NEEDS DESCRIPTION⚡",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752420/HomePage%20Thumbs/ambience_prwino_render_ikikc6_bv8mws.jpg", selected: false,
          category: "competition",
        },
        {
          id: 12,
          title: "Water Me",
          subTitle: "A smart remote watering system",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611752427/HomePage%20Thumbs/WaterMeLong_ylbiyo_hkvtm0.jpg",
          selected: false,
          category: "competition",
        },
        {
          id: 13,
          title: "MetaBalls Animation",
          subTitle: "A smart remote watering system",
          imgSrc:
            "https://res.cloudinary.com/dyxlwvrnp/image/upload/v1611750440/HomePage%20Thumbs/Robot_a453bd.png", selected: false,
          category: "competition",
        },
      ],
    };
  }
  IncrementItem = () => {
    this.setState({ clicks: this.state.clicks + 1 });
  };
  DecreaseItem = () => {
    console.log("click", this.state);
    if (this.state.clicks > 1) {
      this.setState({ clicks: this.state.clicks - 1 });
    }
  };

  handleCardClick = (id, card) => {
    const { history } = this.props;
    history.push(`/${card}`)
  };

  makeCategories = (items) => {
    // console.log('cat', items)
    const uniqueItems = [...new Set(items.map((item) => item.category))];
    // console.log('unique', uniqueItems)
    return uniqueItems.map((item, id) => {
      return <Category category={item} id={id} />;
    });
  };

  makeItems = (items) => {
    return items.map((item) => {

      return (
        <div className='link-to-card' onClick={(e) => { this.handleCardClick(item.id, item.title, e) }}>
          <Card item={item} />
          </div>
      );
    });
  };

  checkWidth = () => {
    if (window.innerWidth > 600) return { columns: `${this.state.clicks}` };
  };

  render() {
    return (
      <Container fluid={true}>
        <div className="categories">
          {/* {this.makeCategories(this.state.items)} */}
        </div>
        <div className="grid-zoom">
          <p onClick={this.DecreaseItem}>+</p>
          <p onClick={this.IncrementItem}>-</p>
        </div>
        <div className="project-container">
          <div className="row-project" style={this.checkWidth()}>
            {this.makeItems(this.state.items)}
          </div>
        </div>
      </Container>
    );
  }
}

export default withRouter(Carousel);
